
































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
@Component({
    name:'contractAddTypeModal'
})
export default class ContractAddTypeModal extends AbpBase  {
    addModal:any = {
        typeIsShow: false,
        mainIsShow: false,
        specialIsShow: false
    }
    //合同登记选择类型弹窗-设置
    ContractTypeSet(type:any) {
        (this as any).$parent.$parent.GetContractType(type);
    }
}
